export const FIND_PORTAL_PACING_MS = 1400;
export const FIND_PORTAL_HANDOFF_MS = 1400;
